export const symbolApi = {
    symbol: {
        getSentiments: '/symbol/sentiments',
        getSentimentsHistory: '/symbol/sentiments_history',
        getSignals: '/symbol/signals',
        getLines: '/symbol/lines',
        list: '/symbols',
        updateIsSentiment: '/symbol/update_is_sentiment',
        updateWatch: '/symbol/update_watch'
    },
}